import { getDefaultTheme } from './getDefaultTheme'

export const getCrowdCatchTheme = isNewStylesThemeEnabled => {
  return getDefaultTheme(
    {
      brandPrimary: '167F7E',
      brandPrimaryLight: 'faec25'
    },
    isNewStylesThemeEnabled
  )
}
